export const MIXPANEL_EVENTS = {
  TIME_SEGMENT_CHANGED: 'People Gantt - Time Segment Changed',
  GANTT_SETTINGS: 'People Gantt - Gantt options',
  PROJECT_BAR_COLOR: 'People Gantt - Project bar color',
};
